import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/ui/Button';

const screens = [
  {
    title: 'Meet People Who\nMatch Your Vibe',
    subtitle: 'Our AI-powered matching connects you with people who truly resonate with your energy and interests.',
    emoji: '✨',
    gradient: ['#FF3D71', '#EC4899'],
  },
  {
    title: 'More Than\nJust A Swipe',
    subtitle: 'Dive into meaningful conversations with personality prompts, compatibility scores, and shared interests.',
    emoji: '💜',
    gradient: ['#8B5CF6', '#A855F7'],
  },
  {
    title: 'Find Something\nReal',
    subtitle: 'Verified profiles, safety features, and genuine connections. Because you deserve something real.',
    emoji: '💫',
    gradient: ['#FF3D71', '#8B5CF6'],
  },
];

const Onboarding = () => {
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();

  const handleNext = () => {
    if (current < screens.length - 1) {
      setCurrent(c => c + 1);
    } else {
      localStorage.setItem('vibe_onboarded', 'true');
      navigate('/login');
    }
  };

  const screen = screens[current];

  return (
    <div style={{
      height: '100vh', display: 'flex', flexDirection: 'column',
      background: '#08080C', position: 'relative', overflow: 'hidden',
    }}>
      {current < screens.length - 1 && (
        <button onClick={() => { localStorage.setItem('vibe_onboarded', 'true'); navigate('/login'); }}
          style={{
            position: 'absolute', top: 16, right: 20, zIndex: 10,
            background: 'none', border: 'none', color: '#71717A',
            fontSize: 14, fontWeight: 500, cursor: 'pointer', padding: 8,
            fontFamily: 'Inter, sans-serif',
          }}>Skip</button>
      )}

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '0 32px' }}>
        <div style={{
          width: 160, height: 160, borderRadius: 40, marginBottom: 40,
          background: `linear-gradient(135deg, ${screen.gradient[0]}20, ${screen.gradient[1]}20)`,
          border: `1px solid ${screen.gradient[0]}30`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 64,
          animation: 'float 3s ease-in-out infinite',
        }}>
          {screen.emoji}
        </div>

        <h1 style={{
          fontSize: 32, fontWeight: 800, textAlign: 'center', lineHeight: 1.2,
          marginBottom: 16, letterSpacing: '-0.02em',
          whiteSpace: 'pre-line',
        }}>{screen.title}</h1>

        <p style={{
          fontSize: 15, color: '#71717A', textAlign: 'center',
          lineHeight: 1.6, maxWidth: 320,
        }}>{screen.subtitle}</p>
      </div>

      <div style={{ padding: '0 32px 40px' }}>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginBottom: 32 }}>
          {screens.map((_, i) => (
            <div key={i} style={{
              height: 4, borderRadius: 2, transition: 'all 0.3s ease',
              width: i === current ? 32 : 8,
              background: i === current ? 'linear-gradient(135deg, #FF3D71, #8B5CF6)' : 'rgba(255,255,255,0.1)',
            }} />
          ))}
        </div>
        <Button onClick={handleNext} fullWidth size="lg">
          {current < screens.length - 1 ? 'Continue' : 'Get Started'}
        </Button>
      </div>
    </div>
  );
};

export default Onboarding;
